import Vue from "vue";
import Vuex from "vuex";
import { persistentStorage } from "./persistence";
import { user } from "./user";
import env from "@/helpers/env";

Vue.use(Vuex);

let store;
const storeVersion = 1;

async function loadStore(callback) {
  store = new Vuex.Store({
    modules: {
      user,
      //    alert,
      //    nav,
      //    contract
    },
    state: {
      version: "",
      canSubmitInvoice: false,
      canSubmitClaim: false,
      apiMode:
        process.env.NODE_ENV === "development"
          ? "dev"
          : process.env.NODE_ENV === "staging"
          ? "stg"
          : "prd",
      modeBanner: process.env.NODE_ENV === "development",
      devMenu: process.env.NODE_ENV === "development",
      openings: 0,
      recentRoute: "/",
      recentRatingVersion: null,
      recentRatingRequest: null,
      recentNpsRequest: null,
      welcomeShowed: false,
      pagesLoaded: false,
      claimSubmission: null,
      settings: {},
      tutorial: [],
      lastHint: [],
      survey: {
        completed_at: null,
      },
      tellja: {
        completed_at: null,
        promotion_completed_at: null,
      },
      hills4me: {
        completed_at: null,
      }
    },
    mutations: {
      incrementOpenings(state) {
        ++state.openings;
      },
      resetOpenings(state) {
        state.openings = 0;
      },
      setApiMode(state, mode) {
        state.apiMode = mode;
      },
      setDevMenu(state, to) {
        state.devMenu = to;
      },
      setModeBanner(state, to) {
        state.modeBanner = to;
      },
      setRecentRoute(state, to) {
        state.recentRoute = to;
      },
      canSubmitInvoice(state, to) {
        state.canSubmitInvoice = to;
      },
      canSubmitClaim(state, to) {
        state.canSubmitClaim = to;
      },
      setRecentRatingVersion(state) {
        let v = String(env.appVersion).split(".");

        state.recentRatingVersion = v[0] + "." + v[1];
      },
      resetRecentRatingVersion(state) {
        state.recentRatingVersion = null;
      },
      setRecentRatingRequest(state) {
        state.recentRatingRequest = new Date().getTime();
      },
      resetRecentRatingRequest(state) {
        state.recentRatingRequest = null;
      },
      setRecentNpsRequest(state) {
        state.recentNpsRequest = new Date().getTime();
      },
      resetRecentNpsRequest(state) {
        state.recentNpsRequest = null;
      },
      setSettings(state, to) {
        state.settings = to;
      },
      setWelcomeShowed(state) {
        state.welcomeShowed = true;
      },
      setPagesLoaded(state, to) {
        state.pagesLoaded = to;
      },
      setClaimSubmission(state, to) {
        state.claimSubmission = to;
      },
      setTutorial(state, to) {
        const index = state.tutorial?.findIndex((t) => t.type === to.type);

        if (index >= 0) {
          state.tutorial[index] = to;
        } else {
          state.tutorial.push(to);
        }
      },
      setLastHintDate(state, to) {
        const index = state.lastHint?.findIndex((t) => t.prefix === to.prefix);

        if (index >= 0) {
          state.lastHint[index] = to;
        } else {
          state.lastHint.push(to);
        }
      },

      setSurveyCompletedAt(state, to) {
        state.survey.completed_at = to;
      },

      setTelljaCompletedAt(state, to) {
        state.tellja.completed_at = to;
      },

      setTelljaPromoCompletedAt(state, to) {
        state.tellja.promotion_completed_at = to;
      },

      setHills4MeCompletedAt(state, to) {
        state.hills4me.completed_at = to;
      }
    },
    getters: {
      getTelljaOrHills4MePopupToShow(state) {
        const telljaSeen = !!state.tellja.completed_at;
        const hills4meSeen = !!state.hills4me.completed_at;
    
        // If both popups are already seen, show nothing
        if (telljaSeen && hills4meSeen) {
          return null;
        }
    
        // Randomly pick one if neither is seen
        let preferredPopup = Math.random() < 0.5 ? "tellja" : "hills4me";
    
        // If preferred popup is already seen, return the other one
        if (preferredPopup === "tellja" && telljaSeen) {
          return "hills4me";
        } else if (preferredPopup === "hills4me" && hills4meSeen) {
          return "tellja";
        }
    
        return preferredPopup;
      },
    },
  });

  store.subscribe((mutation, state) => {
    persistentStorage.save(state);
  });

  let storedState = await persistentStorage.load();

  if (storedState.version === storeVersion) {
    store.replaceState(Object.assign(store.state, storedState));
  } else {
    store.state.version = storeVersion;
  }

  callback(store);
}

export { store, loadStore, persistentStorage };
